import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/ui-bits";
import { fmtDateTime } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const MODULES = ["auth", "accounts", "settlements", "communications", "payments", "tenants", "users", "workflows", "reports", "tasks"];

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [module, setModule] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    const params = module ? { module } : {};
    api.get("/audit", { params }).then((r) => setLogs(r.data)).catch(() => {});
  }, [module]);

  const filtered = logs.filter((l) =>
    !q || l.user_name?.toLowerCase().includes(q.toLowerCase()) || l.action?.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Log" subtitle="Immutable record of all platform activity" />
      <div className="flex gap-3 mb-4">
        <Input placeholder="Search user or action…" value={q} onChange={(e) => setQ(e.target.value)} className="rounded-sm max-w-xs" data-testid="audit-search" />
        <Select value={module || "all"} onValueChange={(v) => setModule(v === "all" ? "" : v)}>
          <SelectTrigger className="w-44 rounded-sm" data-testid="audit-module-filter"><SelectValue placeholder="Module" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Modules</SelectItem>
            {MODULES.map((m) => <SelectItem key={m} value={m} className="capitalize">{m}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="label-caps border-b border-border bg-secondary/40">
              <th className="text-left p-3">Time</th>
              <th className="text-left p-3">User</th>
              <th className="text-left p-3">Action</th>
              <th className="text-left p-3">Module</th>
              <th className="text-left p-3">Detail</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((l) => (
              <tr key={l.id} className="border-b border-border last:border-0 hover:bg-secondary/50">
                <td className="p-3 mono text-xs text-muted-foreground whitespace-nowrap">{fmtDateTime(l.created_at)}</td>
                <td className="p-3 font-medium">{l.user_name}</td>
                <td className="p-3"><span className="mono text-xs bg-secondary px-2 py-0.5 rounded-sm">{l.action}</span></td>
                <td className="p-3 capitalize text-muted-foreground">{l.module}</td>
                <td className="p-3 text-muted-foreground text-xs max-w-md truncate">{l.detail || l.entity_id}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && <Empty text="No audit records" />}
      </div>
    </div>
  );
}
